// Robust copy & share helpers that never throw / never leave unhandled rejections
// (fixes iOS Safari "Script error." overlay from rejected navigator.share/clipboard).

export async function copyText(text) {
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch {
    /* fall through to legacy path */
  }
  try {
    const ta = document.createElement("textarea");
    ta.value = text;
    ta.setAttribute("readonly", "");
    ta.style.position = "fixed";
    ta.style.top = "-1000px";
    ta.style.opacity = "0";
    document.body.appendChild(ta);
    ta.focus();
    ta.select();
    const ok = document.execCommand("copy");
    document.body.removeChild(ta);
    return ok;
  } catch {
    return false;
  }
}

// Returns "shared" | "cancelled" | "copied" | "failed"
export async function shareLink({ title, text, url }) {
  if (navigator.share) {
    try {
      await navigator.share({ title, text, url });
      return "shared";
    } catch (e) {
      if (e && (e.name === "AbortError" || e.name === "NotAllowedError")) return "cancelled";
      /* fall through to copy */
    }
  }
  const ok = await copyText(url);
  return ok ? "copied" : "failed";
}

// Returns "shared" | "cancelled" | "downloaded" | "failed"
export async function shareImage(dataUrl, filename, meta) {
  try {
    const res = await fetch(dataUrl);
    const blob = await res.blob();
    const file = new File([blob], filename, { type: blob.type || "image/png" });
    if (navigator.canShare && navigator.canShare({ files: [file] }) && navigator.share) {
      await navigator.share({ files: [file], title: meta?.title, text: meta?.text });
      return "shared";
    }
  } catch (e) {
    if (e && (e.name === "AbortError" || e.name === "NotAllowedError")) return "cancelled";
    /* fall through to download */
  }
  try {
    const a = document.createElement("a");
    a.href = dataUrl;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    return "downloaded";
  } catch {
    return "failed";
  }
}

